import { render } from "./ColaVentasLocal.vue?vue&type=template&id=ed6241e0"
import script from "./ColaVentasLocal.vue?vue&type=script&lang=js"
export * from "./ColaVentasLocal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__